exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.overflow-on .cell {\r\n  overflow: visible;\r\n  overflow-x: visible;\r\n  overflow-y: visible;\n}\nhr {\r\n  color: #ababab;\n}\n.demo-table-expand {\r\n  font-size: 0;\n}\n.demo-table-expand label {\r\n  width: 90px;\r\n  color: #141516;\n}\n.demo-table-expand .el-form-item {\r\n  margin-right: 0;\r\n  margin-bottom: 0;\r\n  width: 50%;\n}\r\n", ""]);

// exports
